import { SupervisorAccount } from "@material-ui/icons";
import i18next from "i18next";
import { defaultRowButtonsCreator } from "lego-gui-lib";
import { LoggerFactory } from "lego-gui-lib/lib";
import React from "react";
import { RowButton } from "../../common/RowButtons";
import { mainStore } from "../../core/mainStore";
import { showErrorMessage } from "../tree/treeBlock/schema/validators";
import { runInAction } from "mobx";

const log = LoggerFactory.create("CustomerRowButtons");

export const CustomerRowButtons = (
  canCreate: boolean,
  canSelectCustomerContext: boolean
) => {
  const defaultButtonsConfig = {
    /** SAN Admin does not need this edit view, he has `select` option */
    edit: canCreate,
    delete: canCreate,
    copy: true,
    export: true
  };

  return (ctrl: any) => (row: any, key: string, close: () => void) => {
    const buttonsCreator = defaultRowButtonsCreator(defaultButtonsConfig)(ctrl);
    const buttons = buttonsCreator(row, key, close);

    const selectCustomerContext = async () => {
      try {
        await mainStore.customer.oneDataSource.findOne({ id: row.id });
        /** Customer Owner needs a specific role assigned for myCustomer selection to distinguish read/write access */
        if (mainStore.auth.isCustomerOwner()) {
          /** persist customer selection */
          window.localStorage.setItem("customerOwnerLastCustomerRef", row.id);
          runInAction(() => {
            mainStore.auth.assignCustomerRole(row.id);
          });
        }
        mainStore.commons.newSuccess(
          i18next.t("hns:customer:selectContextSuccess")
        );
      } catch (e) {
        showErrorMessage("hns:customer:selectContextFailed");
        log.error("select customer context failed", e);
      }
      close();
    };

    if (canSelectCustomerContext) {
      buttons.push(
        <RowButton
          callbackFunction={selectCustomerContext}
          title={["hns:customer:selectContext", "Download"]}
          key={"download"}
          requiredAccess={"readable"}
        >
          <SupervisorAccount />
        </RowButton>
      );
    }

    return buttons;
  };
};
